module.exports = __webpack_public_path__ + "static/media/close_cross_icon.b6164a77.svg";